export const URL_PORTAL_PATH = '/portal/';
export const URL_STANDALONE_PATH = '/standalone/';

/**
 * Builds the redirect URL using view type and view.
 * @param viewName the view name
 * @param viewConf the view configuration
 * @returns {string|null} the redirect URL
 */
export function buildRedirectUrl(viewName, viewConf) {
  return viewConf ? `${URL_PORTAL_PATH}${viewConf.type}/${viewName}` : null;
}

/**
 * Builds the standalone file viewer URL, as a same-document reference.
 * The portal is a HashRouter SPA: the route only exists behind the hash, so it must be resolved
 * client-side. Keeping the reference relative also preserves the current document base and its
 * "app" query parameter, which carries the application context.
 * @param hash the document hash
 * @returns {string} the standalone file viewer URL
 */
export function buildStandaloneFileViewerUrl(hash) {
  return `#${URL_STANDALONE_PATH}viewer/fileviewer/${hash}`;
}

/**
 * Gets the root URL.
 * @param location the current react router location
 * @returns {string} the root URL
 */
export function getRootURL(location) {
  if (isStandaloneURL(location)) {
    return URL_STANDALONE_PATH;
  }
  return URL_PORTAL_PATH;
}

/**
 * Checks if the location is a "standalone" URL.
 * @param location the current react router location
 * @returns {*} true if the location is a "standalone" URL
 */
export function isStandaloneURL(location) {
  return location?.pathname?.includes(URL_STANDALONE_PATH);
}
